(function ($) {

'use strict';

	/**
	 * Output message info box
	 */
	$.initGoogleElems = function () {
		$('.googleelem').on('click', function(){
			
			// code should only be executed if user consented to cookies
			
			let $iframe = $('<iframe>');
			
			$.each(this.attributes, function () {
				// this.attributes is not a plain object, but an array
				// of attribute nodes, which contain both the name and value
				if (this.specified && this.name.substr(0, 5) === 'data-') {
					$iframe.attr(this.name.substr(5), this.value);
				}
			});
			
			$iframe.removeClass('googleelem');
			$(this).replaceWith($iframe);
		});
		
	};	// $.fn.initPageInfoMessage

}(jQuery));

